import React from 'react';
import { connect } from 'react-redux';
import Mapping from './product-mapping';
import Preview from './export-content-preview/container';
import ExportResults from './exportResult';
import { Stepper, Step, StepLabel, Paper, CardHeader, FontIcon, Avatar, StepButton, Dialog, FlatButton } from 'material-ui';
import RaisedButton from '../../tc-ui/raised-button-with-loader';
import {
  checkIfHasRates as checkIfHasRatesAction,
  getConvertedContract as getConvertedContractAction,
  exportContract as exportContractAction,
  updateWithKeyPath as updateWithKeyPathAction,
  clearExportState as clearExportStateAction,
  getContract as getContractAction,
  getAuth as getAuthAction,
  markContractAsLoaded as markContractAsLoadedAction,
} from '../../../stores/integration/integration-actions';
import LogIn from '../integration-tourplan-login';
import LoadingOverlay from '../../tc-ui/loading-overlay';
import R from 'ramda';
import pluralize from 'pluralize';

const propTypes = {
  params: React.PropTypes.object,
  exportContract: React.PropTypes.func,
  history: React.PropTypes.object,
  user: React.PropTypes.object,
  contract: React.PropTypes.object,
  updateWithKeyPath: React.PropTypes.func,
  sendMsg: React.PropTypes.func,
  getConvertedContract: React.PropTypes.func,
  clearExportState: React.PropTypes.func,
  displayExportPreview: React.PropTypes.bool,
  dialogOpen: React.PropTypes.bool,
  convertedContract: React.PropTypes.array,
  exportStep: React.PropTypes.number,
  checkIfDupeRateNameExistsWithinADateRange: React.PropTypes.func,
  getContract: React.PropTypes.func,
  getAuth: React.PropTypes.func,
  exportStatus: React.PropTypes.string,
  ratePackageIds: React.PropTypes.array,
  markContractAsLoaded: React.PropTypes.func,
  updatingContractState: React.PropTypes.bool,
};

class ExportContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillMount() {
    const { getContract, getAuth, params } = this.props;
    const { contractID } = params;
    getContract(contractID);
    getAuth();
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== React.PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  componentWillUnmount() {
    this.props.clearExportState();
  }

  _dialogHide = () => {
    this.props.updateWithKeyPath(['dialogOpen'], false);
  };
  convertErrorCode = (exportError) => {
    return R.call(R.cond([
      [R.equals('500'), R.always('Sorry, please try again or inform our customer support team if it failed again!')],
      [R.equals(500), R.always('Sorry, please try again or inform our customer support team if it failed again!')],
      [R.equals('503'), R.always('Sorry, this service is temporarily not available.')],
      [R.equals('404'), R.always('Products are not correctly mapped, please check!')],
      [R.equals('TOOOOO LOOOOOG'), R.always("Looks like it would take a while to export all of these rate bands, please feel free to work on other stuff and we will email you once all rate bands are successfully exported")],
      [R.T, R.identity],
    ]), exportError);
  };
  render() {
    const {
      contract,
      exportStatus,
      updateWithKeyPath,
      exportStep,
      exportContract,
      convertedContract,
      ratePackageIds,
      checkIfDupeRateNameExistsWithinADateRange,
      markContractAsLoaded,
      updatingContractState,
      dialogOpen,
    } = this.props;
    const ifDupeRateNameExistsAtAll = convertedContract.some(({ forTourplan }) => forTourplan.some(({ DateRange }) => checkIfDupeRateNameExistsWithinADateRange(DateRange)));

    const hasRates = Boolean(R.find(
      R.propEq('hasRates', true),
      contract && contract.products
      ? contract.products.filter(obj => ratePackageIds.indexOf(obj._id) > -1)
      : [],
    ));
    const missingPriceCodesOrTaxCodes = convertedContract.some(({ forTourplan }) => forTourplan.some(({ DateRange }) =>
     !(DateRange.PriceCodes && DateRange.PriceCodes.length)
     || !(DateRange.Taxes && DateRange.Taxes.TaxInfo && DateRange.Taxes.TaxInfo.Tax)
    ));
    const numOfDateBlocks = convertedContract.reduce((total, o) => total + o.forTourplan.length, 0);
    return (
    <div className="l-app-content" style={{ marginBottom: '128px', maxWidth: 'calc(100% - 48px)' }}>
      <Paper>
        <CardHeader
          style={{ backgroundColor: '#f5f5f5' }}
          title={<span style={{ fontSize: '20px' }}>{contract.supplierName}</span>}
          subtitle={<a style={{ marginTop: '5px', cursor: 'pointer' }} target="_blank" href={`/contracting/contract/${contract.contractId}/details`}>
            <FontIcon style={{ fontSize: '16px', marginTop: '5px' }} color={"#00bcd4"} className="tc-icon-archive" />
            {` ${contract.locationName}`}
            {
              R.path(['supplierInfo', 'marketInfo'], contract) ? (<small>
                &nbsp;{`(${R.path(['supplierInfo', 'marketInfo'], contract)})`}
              </small>) : <span/>
            }
          </a>}
          avatar={<Avatar src={contract.avatarUrl} size={50} style={{ verticalAlign: 'middle' }} />}
        />
        <Stepper
          activeStep={exportStep - 1}
          linear={false}
          style={{ borderTop: '1px solid #e0e0e0' }}
        >
          <Step>
            <StepButton onTouchTap={() => updateWithKeyPath(['exportStep'], 1)}>Mapping & History</StepButton>
          </Step>
          <Step>
            <StepButton onTouchTap={() => {
              if (convertedContract && convertedContract.length) updateWithKeyPath(['exportStep'], 2);
              else this.props.getConvertedContract(contract.contractId, ratePackageIds);
            }}>Export Preview</StepButton>
          </Step>
          <Step>
            <StepLabel>Export Results</StepLabel>
          </Step>
        </Stepper>
      </Paper>
      <div style={{ marginBottom: '24px' }}>
        {
          R.call(R.cond([
            [R.equals(2), R.always(<Preview {...this.props} />)],
            [R.equals(3), R.always(<ExportResults
              exportResponses={contract.exportResponses}
              markContractAsLoaded={markContractAsLoaded}
              contractId={contract.contractId}
              state={contract.state}
              updatingContractState={updatingContractState}
            />)],
            [R.T, R.always(<Mapping {...this.props}/>)],
          ]), exportStep)
        }
      </div>
      {
        R.call(R.cond([
          [R.equals(2), R.always(<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <RaisedButton label="Back" onTouchTap={() => updateWithKeyPath(['exportStep'], 1)} primary />
            {missingPriceCodesOrTaxCodes && (
              <div style={{ display: 'flex', alignItems: 'center', textAlign: 'left', overflow: 'auto', marginLeft: '8%', marginTop: '10px', height: '64px' }}>
                <FontIcon className="tc-icon-warning2" color="#ff9100" />
                <div style={{ display: 'inline-block', marginLeft: '8px', color: "#ff9100" }}>
                  {'Please be informed that some date ranges you are trying to export are missing Tax Code or Price Codes.'}
                </div>
              </div>
            )}
            <RaisedButton
              label={hasRates ? 'Confirm and Re-export' : 'Confirm and export'}
              loader={exportStatus === 'exporting'}
              onClick={() => {
                if (!hasRates || window.confirm('Tourplan currently has rates for the one (or more) of the options that you are going to export rates into. Are you sure you want to ovewrite the existing data?')) {
                  exportContract(contract, convertedContract);
                }
              }}
              disabled={ifDupeRateNameExistsAtAll}
              labelStyle={{ textTransformation: 'none' }} secondary
            />
          </div>)],
          [R.equals(3), R.always(<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <RaisedButton
              label="Go Back and Try Again"
              onTouchTap={() => {
                updateWithKeyPath(['exportStep'], 2);
                updateWithKeyPath(['contract', 'exportResponses'], null);
              }}
              primary
            />
            <RaisedButton
              label="Export Another Contract"
              onClick={() => this.context.router.push('/integration/contracts')}
              labelStyle={{ textTransformation: 'none' }} secondary
            />
          </div>)],
          [R.T, R.always(<div/>)],
        ]), exportStep)
      }
      <LoadingOverlay
        loading={['gettingConvertedContract', 'exporting', 'checkingRates'].indexOf(exportStatus) > -1}
        text={exportStatus === 'exporting' && numOfDateBlocks > 5 ? `We are exporting ${
          convertedContract.length
        } ${
          pluralize('Option', convertedContract.length)
        }, ${numOfDateBlocks} Date ${pluralize('Band', numOfDateBlocks)}...` : ''}
      />
      <Dialog
        title={contract.exportError === '401' ? '' : 'Oops!'}
        open={dialogOpen}
        onRequestClose={this._dialogHide}
        actions={[
          <FlatButton
            label="Close"
            secondary
            disableTouchRipple
            onClick={this._dialogHide}
          />,
        ]}
        modal={false}
      >
        {
          contract.exportError === '401' ? <LogIn {...this.props} transition={this._dialogHide} type="validate"/>
            : this.convertErrorCode(contract.exportError)
        }
      </Dialog>
    </div>
    );
  }
}

const mapStateToProps = ({ integration }) => ({
  displayExportPreview: integration.get('displayExportPreview'),
  exportStatus: integration.get('exportStatus'),
  exportStep: integration.get('exportStep'),
  dialogOpen: integration.get('dialogOpen'),
  ratePackageIds: integration.get('ratePackageIds') ? integration.get('ratePackageIds').toJS() : [],
  contract: integration.get('contract') ? integration.get('contract').toJS() : {},
  updatingContractState: integration.get('updatingContractState'),
  convertedContract: integration.get('convertedContract') ? integration.get('convertedContract').toJS() : [],
});

const mapDispatchToProps = dispatch => ({
  getContract: (...args) => dispatch(getContractAction(...args)),
  getAuth: (...args) => dispatch(getAuthAction(...args)),
  checkIfHasRates: (...args) => dispatch(checkIfHasRatesAction(...args)),
  getConvertedContract: (...args) => dispatch(getConvertedContractAction(...args)),
  markContractAsLoaded: (...args) => dispatch(markContractAsLoadedAction(...args)),
  exportContract: (...args) => dispatch(exportContractAction(...args)),
  updateWithKeyPath: (...args) => dispatch(updateWithKeyPathAction(...args)),
  clearExportState: (...args) => dispatch(clearExportStateAction(...args)),
  checkIfDupeRateNameExistsWithinADateRange: R.compose(
    R.any(array => array.length > 1),
    R.groupWith(R.eqProps('Stay_Type')),
    R.prop('RateSet')
  ),
});
ExportContainer.propTypes = propTypes;
ExportContainer.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(ExportContainer);




// WEBPACK FOOTER //
// ./src/app/components/integration/export/export-container.jsx